import { isSSR } from '@front10/utils';

const getRedirect = (url) => {
  if (isSSR()) {
    return;
  }

  window.open(url, '_top');
};

const buildUrl = (props) => {
  const { data } = props;
  return !data || !data.id
    ? 'https://www.airbnb.com/s/homes'
    : `https://www.airbnb.com/rooms/${data.id}?guests=1&adults=1&sl_alternate_dates_exclusion=true&source_impression_id=p3_1558945698_vsSyR8czEOk8m%2Fr7`;
};

const detailHouse = (props) => {
  const url = buildUrl(props);
  if (url) {
    getRedirect(url);
  }
};

export default detailHouse;
